<template>
  <Popup style="background-color: rgba(0, 0, 0, 0);" v-model:show="show">
    <div class="p-box">
      <div class="p-box__card">
        <div class="p-box__title">{{ title }}</div>
        <div class="p-box__content">
          <div v-for="text in content.split(/\n/)" :key="text">{{ text }}</div>
        </div>
      </div>
      <div class="p-box__close" @click="close"></div>
    </div>
  </Popup>
</template>
<script setup>
import { Popup } from 'vant';
import { ref } from "vue";
const title = ref('')
const content = ref('')
const show = ref(false)
const close = () => {
  show.value = false
}
const open = (data) => {
  title.value = data.title ? data.title : ''
  content.value = data.content ? data.content : ''  
  show.value = true
}
// eslint-disable-next-line no-undef
defineExpose({
  close,
  open
})
</script>
<style scoped>
.p-box__card {
  padding: 40px;
  font-size: 24px;
  line-height: 36px;
  color: #A2A3A4;
  border-radius: 8px;
  width: 590px;
  background-color: #171A1B;
  position: relative;
  overflow: hidden;
}

.p-box__card::after {
  content: "";
  display: block;
  background-color: #f00;
  height: 600px;
  width: 600px;
  position: absolute;
  top: 0;
  right: -300px;
  transform: rotate(45deg);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));
  z-index: 1;
}

.p-box__card>* {
  position: relative;
  z-index: 2;
}

.p-box__title {
  font-size: 32px;
  color: #FFFFFF;
  opacity: 0.9;
  text-align: center;
  margin-bottom: 30px;
}

.p-box__close {
  width: 80px;
  height: 80px;
  margin: 60px auto 0;
  background: url('@/static/image/popup-close.png') center / 100% no-repeat;
}

.p-box__content {
  overflow: auto;
  max-height: 60vh;
}
.p-box__content div {
  min-height: 24px;
}
</style>